import Vue from 'vue';
import {
  Button,
  Field,
  RadioGroup,
  Radio,
  Area,
  Cell,
  CellGroup,
  ActionSheet,
  Toast,
  Dialog,
  Image,
  Tabbar,
  TabbarItem,
  Icon,
  Switch,
  Card,
  SubmitBar,
  Popup,
  List,
  Tab,
  Tabs,
  Picker,
  ImagePreview,
  Steps,
  Step,
  Search,
  Sidebar,
  SidebarItem,
  Empty,
  Stepper,
  SwipeCell,
  CheckboxGroup,
  Checkbox,
  PullRefresh,
  Overlay,
  ModalSheet,
  Popover,
  Uploader,
  Skeleton,
  NoticeBar,
  IndexBar,
  IndexAnchor,
  Dot
} from '@zyf2e/capui-mobile';
Vue.use(Button)
  .use(Field)
  .use(RadioGroup)
  .use(Radio)
  .use(Area)
  .use(Cell)
  .use(CellGroup)
  .use(ActionSheet)
  .use(Toast)
  .use(Dialog)
  .use(Image)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Icon)
  .use(Switch)
  .use(Card)
  .use(SubmitBar)
  .use(List)
  .use(Tab)
  .use(Tabs)
  .use(ImagePreview)
  .use(Picker)
  .use(Steps)
  .use(Step)
  .use(Search)
  .use(Sidebar)
  .use(SidebarItem)
  .use(Empty)
  .use(Stepper)
  .use(SwipeCell)
  .use(CheckboxGroup)
  .use(Checkbox)
  .use(PullRefresh)
  .use(Popup)
  .use(Overlay)
  .use(ModalSheet)
  .use(Popover)
  .use(Uploader)
  .use(Skeleton)
  .use(NoticeBar)
  .use(IndexBar)
  .use(IndexAnchor)
  .use(Dot);
